import { Link } from 'react-router';
import { useSingleColumn } from '../../hooks/useMedia';
import { useT } from '../../i18n';
import { doneCards, useCards, useBoardCards } from '../../store/cards';
import controls from '../controls.module.css';
import { BoardSwitch } from '../Boards/BoardSwitch';
import { useOrderedBoards } from '../../hooks/useBoards';
import { EnergyLens } from '../EnergyLens/EnergyLens';
import { Gear, Journal } from '../icons';
import { SyncDot } from '../SyncDot/SyncDot';
import styles from './TopBar.module.css';

export function TopBar() {
  const t = useT();
  const single = useSingleColumn();
  const several = useOrderedBoards().length > 1;
  const cards = useBoardCards();
  const doneCount = doneCards(cards).length;
  return (
    <header className={styles.top}>
      <div className={styles.left}>
        <SyncDot />
        {single || several ? <div className={`display ${styles.brand}`}>{t.t('app.name')}</div> : <BoardSwitch />}
      </div>
      <div className={styles.center} data-tour="lens">
        <EnergyLens />
      </div>
      <div className={styles.right}>
        <Link to="/done" className={controls.iconbtn} aria-label={t.t('nav.journal')} title={t.t('nav.journal')}>
          <Journal size={20} />
          <span className={styles.count}>{doneCount}</span>
        </Link>
        <Link to="/settings" className={controls.iconbtn} aria-label={t.t('nav.settings')} title={t.t('nav.settings')}>
          <Gear size={20} />
        </Link>
      </div>
    </header>
  );
}
